import React from 'react'
import styled from 'styled-components'
import { FooterMenuSubItem, FooterProps } from '../../footer.props'
import { Link, useCookies, useLocalLabels } from '@sentecacommerce-theme/lib'

export const SubMenu = ({ items, contentMaxWidth }: SubMenuProps) => {
  const { deleteCookies } = useCookies()

  return (
    <List>
      {items.map((item) => {
        if (item.url === '#cookies') {
          return (
            <Item
              key={`Item__${item.url}`}
              maxWidth={contentMaxWidth}
              onClick={() => deleteCookies()}
            >
              <a href="#cookies">{item.label}</a>
            </Item>
          )
        }
        return (
          <Item key={`Item__${item.url}`} maxWidth={contentMaxWidth}>
            <Link passHref key={`${item.url}__${item.label}`} href={item.url}>
              <a>{item.label}</a>
            </Link>
          </Item>
        )
      })}
    </List>
  )
}

type SubMenuProps = {
  items: FooterMenuSubItem[]
  contentMaxWidth?: string
}

const List = styled.ul``

const Item = styled.li<{ maxWidth?: string }>`
  padding: 1rem 0;
  font-size: 1.4rem;
  cursor: pointer;
  
  @media (min-width: ${({ theme }) => theme.breakpoints.lg.min}) {
    max-width: ${({ maxWidth }) => (maxWidth ? maxWidth : 'auto')};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.xxl.min}) {
    max-width: max-content;
  }

  & a, span {
    display: inline;
    transition: all 0.1s ease;
    &:hover {
      color: ${({ theme }) => theme.palette.silverTree};
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.lg.min}) {
    padding: 1.6rem 0 0 0;
  }
`
